/**
 * @generated SignedSource<<956f5502eed32407fe52a76a2054eb5f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalHeaderRefreshedQuery$variables = {
  goalUpdateDraftsEnabled: boolean;
  key: string;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalHeaderRefreshedQuery$data = {
  readonly goal: {
    readonly ari: string;
    readonly " $fragmentSpreads": FragmentRefs<"GoalHeader">;
  } | null;
};
export type GoalHeaderRefreshedQuery = {
  response: GoalHeaderRefreshedQuery$data;
  variables: GoalHeaderRefreshedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalUpdateDraftsEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "ari"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "value"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "messageId"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "LocalizationField"
},
v12 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "GoalTypeCustomName"
    },
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "kind"
},
v14 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "GoalTypeCustomNamePlural"
    },
    (v11/*: any*/)
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "state"
},
v16 = {
  "kind": "ScalarField",
  "name": "key"
},
v17 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "score"
},
v19 = [
  (v8/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v21 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v22 = {
  "kind": "ScalarField",
  "name": "watching"
},
v23 = {
  "kind": "ScalarField",
  "name": "canWatchGoal"
},
v24 = {
  "kind": "ScalarField",
  "name": "archived"
},
v25 = {
  "concreteType": "GoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v6/*: any*/)
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v27 = {
  "kind": "ScalarField",
  "name": "type"
},
v28 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v27/*: any*/)
  ]
},
v29 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v30 = [
  (v10/*: any*/)
],
v31 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v31/*: any*/),
    (v8/*: any*/),
    (v18/*: any*/)
  ]
},
v33 = [
  (v29/*: any*/),
  (v31/*: any*/),
  (v18/*: any*/),
  (v8/*: any*/),
  (v32/*: any*/)
],
v34 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v33/*: any*/)
},
v35 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v36 = {
  "kind": "ScalarField",
  "name": "label"
},
v37 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v38 = {
  "alias": "tooltip",
  "args": (v37/*: any*/),
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(longFormat:true)"
},
v39 = {
  "alias": "localizedTooltip",
  "args": (v37/*: any*/),
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": "localizedLabel(longFormat:true)"
},
v40 = {
  "kind": "ScalarField",
  "name": "overdue"
},
v41 = [
  (v35/*: any*/),
  (v36/*: any*/),
  (v31/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/)
],
v42 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v43 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v44 = {
  "kind": "ScalarField",
  "name": "picture"
},
v45 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v46 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v44/*: any*/),
    (v45/*: any*/)
  ]
},
v47 = [
  (v8/*: any*/),
  (v6/*: any*/)
],
v48 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v47/*: any*/)
},
v49 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v50 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v51 = {
  "kind": "ScalarField",
  "name": "subType"
},
v52 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v53 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v54 = {
  "concreteType": "ProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "concreteType": "ProjectPhaseDetails",
          "kind": "LinkedField",
          "name": "newPhase",
          "plural": false,
          "selections": [
            {
              "alias": "_id",
              "kind": "ScalarField",
              "name": "id"
            }
          ]
        },
        {
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v43/*: any*/),
            (v46/*: any*/)
          ]
        },
        (v16/*: any*/),
        (v5/*: any*/),
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "private"
        },
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "shortName"
            }
          ]
        },
        {
          "concreteType": "IconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "ThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v42/*: any*/),
        {
          "concreteType": "ProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": [
            (v36/*: any*/),
            (v31/*: any*/),
            (v8/*: any*/),
            {
              "concreteType": "CompletionProjectState",
              "kind": "LinkedField",
              "name": "atCompletionState",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                (v36/*: any*/),
                (v31/*: any*/)
              ]
            }
          ]
        },
        (v24/*: any*/),
        {
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "concreteType": "UserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v43/*: any*/),
                    (v6/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    (v53/*: any*/)
  ]
},
v55 = {
  "kind": "ScalarField",
  "name": "count"
},
v56 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v57 = [
  (v5/*: any*/),
  (v44/*: any*/)
],
v58 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v59 = [
  (v58/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v60 = {
  "kind": "ScalarField",
  "name": "time"
},
v61 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v62 = {
  "concreteType": "GoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v19/*: any*/)
},
v63 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v64 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v65 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    (v64/*: any*/)
  ]
},
v66 = {
  "args": (v59/*: any*/),
  "concreteType": "MetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v8/*: any*/),
            (v60/*: any*/),
            {
              "concreteType": "UserPII",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v57/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "GoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v61/*: any*/),
                        {
                          "concreteType": "Goal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": [
                            (v6/*: any*/)
                          ]
                        },
                        (v62/*: any*/),
                        (v6/*: any*/)
                      ]
                    }
                  ],
                  "type": "FromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v61/*: any*/)
                  ],
                  "type": "FromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "FromMetricUpdate"
                }
              ]
            },
            (v7/*: any*/)
          ]
        },
        (v63/*: any*/)
      ]
    },
    (v65/*: any*/),
    (v53/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v67 = {
  "args": (v59/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v68 = {
  "kind": "ScalarField",
  "name": "source"
},
v69 = [
  (v60/*: any*/),
  (v6/*: any*/)
],
v70 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v69/*: any*/)
},
v71 = {
  "kind": "ScalarField",
  "name": "end"
},
v72 = {
  "concreteType": "TargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v71/*: any*/)
  ]
},
v73 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v72/*: any*/)
  ]
},
v74 = {
  "kind": "ScalarField",
  "name": "variance"
},
v75 = {
  "args": (v59/*: any*/),
  "concreteType": "MetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v69/*: any*/)
        },
        {
          "concreteType": "MetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            (v73/*: any*/),
            (v8/*: any*/)
          ]
        },
        (v74/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v76 = {
  "concreteType": "MetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v47/*: any*/)
    },
    (v74/*: any*/)
  ]
},
v77 = [
  (v27/*: any*/),
  (v26/*: any*/)
],
v78 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v77/*: any*/)
},
v79 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v26/*: any*/)
  ]
},
v80 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v64/*: any*/)
  ]
},
v81 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v82 = {
  "concreteType": "WorkspaceAIConfig",
  "kind": "LinkedField",
  "name": "aiConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    }
  ]
},
v83 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v84 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v85 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v83/*: any*/),
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v61/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v43/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v44/*: any*/),
                    (v5/*: any*/),
                    (v84/*: any*/),
                    (v45/*: any*/)
                  ]
                },
                (v6/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v53/*: any*/)
  ]
},
v86 = {
  "kind": "ScalarField",
  "name": "start"
},
v87 = {
  "kind": "ScalarField",
  "name": "summary"
},
v88 = {
  "kind": "ScalarField",
  "name": "title"
},
v89 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v88/*: any*/),
    (v87/*: any*/),
    (v6/*: any*/)
  ]
},
v90 = [
  (v5/*: any*/)
],
v91 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v92 = [
  (v55/*: any*/)
],
v93 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v94 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v95 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v96 = [
  (v8/*: any*/),
  (v6/*: any*/),
  (v60/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalHeaderRefreshedQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v3/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "GoalHeader"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalHeaderRefreshedQuery",
    "selections": [
      {
        "alias": "goal",
        "args": (v3/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "GoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v6/*: any*/),
              (v13/*: any*/),
              {
                "concreteType": "GoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v6/*: any*/),
                  (v15/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "parentGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v16/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "concreteType": "GoalState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v18/*: any*/),
              {
                "concreteType": "CompletionGoalState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": (v19/*: any*/)
              }
            ]
          },
          (v20/*: any*/),
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              }
            ]
          },
          (v24/*: any*/),
          {
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/),
              (v21/*: any*/),
              (v4/*: any*/)
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v6/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canAddLinkedProjects"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveLinkedProjects"
                          }
                        ]
                      },
                      (v21/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v5/*: any*/),
                      (v34/*: any*/),
                      (v42/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          (v46/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v51/*: any*/),
                                      (v6/*: any*/),
                                      (v24/*: any*/)
                                    ]
                                  },
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "args": (v52/*: any*/),
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          (v54/*: any*/),
                          (v53/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      }
                    ]
                  }
                ]
              },
              (v55/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": "connectionId",
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "args": (v56/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v4/*: any*/),
                      (v16/*: any*/),
                      (v5/*: any*/),
                      (v34/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": (v57/*: any*/)
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v51/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v66/*: any*/),
                                      (v67/*: any*/),
                                      (v24/*: any*/),
                                      (v68/*: any*/),
                                      (v70/*: any*/),
                                      (v4/*: any*/),
                                      (v21/*: any*/)
                                    ]
                                  },
                                  (v50/*: any*/),
                                  (v48/*: any*/),
                                  (v6/*: any*/),
                                  (v75/*: any*/),
                                  {
                                    "concreteType": "MetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "MetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "MetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v73/*: any*/),
                                              (v8/*: any*/),
                                              (v76/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v49/*: any*/),
                                  (v4/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v20/*: any*/),
                      (v78/*: any*/),
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": [
                          (v55/*: any*/),
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v24/*: any*/),
                                  (v6/*: any*/),
                                  (v79/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "successMeasure",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v14/*: any*/)
                            ]
                          },
                          (v6/*: any*/),
                          (v13/*: any*/),
                          (v12/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "args": (v56/*: any*/),
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "successMeasures",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v78/*: any*/),
                                  (v24/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "concreteType": "GoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v14/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v80/*: any*/)
                        ],
                        "storageKey": "successMeasures(first:50)"
                      },
                      (v81/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "parentGoal",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              (v80/*: any*/)
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "learningsCount"
          },
          {
            "kind": "ScalarField",
            "name": "risksCount"
          },
          {
            "kind": "ScalarField",
            "name": "decisionsCount"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              (v6/*: any*/),
              (v82/*: any*/),
              {
                "concreteType": "UserCapabilities",
                "kind": "LinkedField",
                "name": "currentUserAppCapabilities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Capability",
                    "kind": "LinkedField",
                    "name": "capabilities",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "capability"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "capabilityContainer"
                      },
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v85/*: any*/),
          (v78/*: any*/),
          {
            "concreteType": "MetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "MetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "MetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "Metric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v27/*: any*/),
                          (v51/*: any*/),
                          (v24/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "externalEntityId"
                          },
                          (v66/*: any*/),
                          (v67/*: any*/),
                          (v68/*: any*/),
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": [
                              (v60/*: any*/),
                              (v6/*: any*/),
                              (v8/*: any*/)
                            ]
                          },
                          (v21/*: any*/)
                        ]
                      },
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v75/*: any*/),
                      {
                        "concreteType": "MetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TargetDate",
                                    "kind": "LinkedField",
                                    "name": "date",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TargetDateRange",
                                        "kind": "LinkedField",
                                        "name": "dateRange",
                                        "plural": false,
                                        "selections": [
                                          (v71/*: any*/),
                                          (v86/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v8/*: any*/),
                                  (v76/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v81/*: any*/),
          {
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v69/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/),
              (v83/*: any*/),
              (v61/*: any*/),
              (v87/*: any*/),
              (v89/*: any*/)
            ]
          },
          {
            "concreteType": "GoalPhaseDetails",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": (v90/*: any*/)
          },
          (v91/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": (v92/*: any*/)
          },
          {
            "alias": "latestUpdates",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v61/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "updates(first:1)"
          },
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "args": (v95/*: any*/),
            "concreteType": "GoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v61/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v21/*: any*/),
                          {
                            "concreteType": "Workspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v6/*: any*/),
                              (v82/*: any*/)
                            ]
                          },
                          (v22/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v21/*: any*/)
                            ]
                          },
                          (v16/*: any*/),
                          (v5/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v61/*: any*/),
                              (v83/*: any*/),
                              (v87/*: any*/),
                              (v89/*: any*/)
                            ]
                          },
                          (v91/*: any*/),
                          (v28/*: any*/),
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v92/*: any*/)
                          },
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v6/*: any*/),
                                      (v48/*: any*/),
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v5/*: any*/),
                                          (v27/*: any*/),
                                          (v51/*: any*/),
                                          (v24/*: any*/),
                                          (v68/*: any*/),
                                          (v70/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "MetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "MetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "MetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v86/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v5/*: any*/),
                              (v84/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v93/*: any*/),
                      (v94/*: any*/),
                      (v4/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v96/*: any*/)
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v5/*: any*/),
                                      (v27/*: any*/),
                                      (v51/*: any*/),
                                      (v24/*: any*/),
                                      {
                                        "args": [
                                          (v58/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "MetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "MetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "MetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v60/*: any*/),
                                                  (v6/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      },
                                      (v68/*: any*/),
                                      (v70/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v96/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v77/*: any*/)
                      },
                      {
                        "args": (v56/*: any*/),
                        "concreteType": "GoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v79/*: any*/),
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      (v85/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasConnectedUpdates"
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": (v90/*: any*/)
                          },
                          (v6/*: any*/)
                        ]
                      },
                      (v83/*: any*/),
                      {
                        "alias": "newGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v29/*: any*/),
                          (v31/*: any*/),
                          (v18/*: any*/),
                          (v32/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v31/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v72/*: any*/)
                        ]
                      },
                      (v87/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v24/*: any*/),
                          (v21/*: any*/),
                          (v88/*: any*/),
                          (v87/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      (v62/*: any*/),
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v41/*: any*/)
                      },
                      {
                        "alias": "oldGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v33/*: any*/)
                      },
                      {
                        "concreteType": "GoalPhaseDetails",
                        "kind": "LinkedField",
                        "name": "newPhase",
                        "plural": false,
                        "selections": (v90/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v6/*: any*/)
                                ]
                              }
                            ],
                            "type": "ProjectUpdate"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ]
                  },
                  (v63/*: any*/)
                ]
              },
              (v65/*: any*/)
            ],
            "storageKey": "updates(first:30)"
          },
          {
            "args": (v95/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "args": (v52/*: any*/),
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              (v55/*: any*/),
              (v54/*: any*/),
              (v53/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          {
            "condition": "goalUpdateDraftsEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "DraftUpdate",
                "kind": "LinkedField",
                "name": "draftUpdate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "input"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/),
                          (v5/*: any*/),
                          (v44/*: any*/)
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  },
                  (v6/*: any*/),
                  (v53/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6e9d82820e944e0e206ef87111b0cef1",
    "id": null,
    "metadata": {},
    "name": "GoalHeaderRefreshedQuery",
    "operationKind": "query",
    "text": "query GoalHeaderRefreshedQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $goalUpdateDraftsEnabled: Boolean!\n) {\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    ari\n    ...GoalHeader\n    id\n  }\n}\n\nfragment ActivityHistorySection on Goal {\n  ...GoalComments\n}\n\nfragment AddToMissedUpdateMessage on Goal {\n  id\n  latestUpdates: updates(first: 1) {\n    edges {\n      node {\n        id\n        creationDate\n        missedUpdate\n        updateType\n      }\n    }\n  }\n}\n\nfragment ArchiveGoal_goalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n    name\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n  goalType {\n    kind\n    successMeasure {\n      ...goalTypeNamePlural\n      id\n    }\n    id\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypePopup on Goal {\n  ...ChangeRollupTypeWarning\n  id\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n  progress {\n    type\n  }\n  subGoals {\n    edges {\n      node {\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          type\n        }\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypeWarning on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment CompactGoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment ContributingProjectsSummary on ProjectConnection {\n  edges {\n    node {\n      archived\n      owner {\n        aaid\n        id\n      }\n      members {\n        edges {\n          node {\n            aaid\n            id\n          }\n        }\n      }\n      state {\n        value\n      }\n      id\n    }\n  }\n}\n\nfragment DraftGoalUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment DueDateContext on Goal {\n  phase {\n    name\n  }\n  latestUpdateDate\n}\n\nfragment EditGoalProgressEditor on GoalUpdate {\n  creationDate\n  goal {\n    metricTargets {\n      edges {\n        node {\n          id\n          metric {\n            id\n          }\n          metricTargetPeriods {\n            edges {\n              node {\n                date {\n                  dateRange {\n                    start\n                  }\n                }\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            id\n          }\n        }\n        newValue {\n          value\n          time\n          id\n        }\n        oldValue {\n          time\n          id\n        }\n        newStartValue\n        newTargetValue\n      }\n    }\n  }\n}\n\nfragment EditGoalUpdate on GoalUpdate {\n  id\n  ari\n  uuid\n  creationDate\n  missedUpdate\n  hasConnectedUpdates\n  summary\n  newPhase {\n    name\n  }\n  newGoalState: newState {\n    score\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    title\n    uuid\n    id\n  }\n  goal {\n    id\n    ari\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n    metricTargets {\n      edges {\n        node {\n          metric {\n            id\n            archived\n          }\n          id\n        }\n      }\n    }\n    parentGoal {\n      uuid\n      id\n    }\n  }\n  ...EditGoalProgressEditor\n}\n\nfragment EditableGoalUpdateCard on GoalUpdate {\n  id\n  goal {\n    id\n  }\n  creationDate\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...GoalUpdateCard\n  ...EditGoalUpdate\n}\n\nfragment EmptyStateNoUpdates on Goal {\n  watching\n  canPostUpdate\n}\n\nfragment GoalAboutTab on Goal {\n  id\n  description\n  goalType {\n    kind\n    id\n  }\n  parentGoal {\n    uuid\n    id\n  }\n  capabilities {\n    canEditMetadata\n  }\n  ...GoalDescription\n  ...GoalComments\n  ...SuccessMeasuresSectionFragment\n  ...SuccessMeasureMetricSection\n  ...ActivityHistorySection\n}\n\nfragment GoalActions on Goal {\n  id\n  ari\n  name\n  capabilities {\n    canArchiveGoal\n  }\n  ...ArchiveGoal_goalActions\n}\n\nfragment GoalComments on Goal {\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalDatePicker on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  targetDate\n  targetDateConfidence\n}\n\nfragment GoalDescription on Goal {\n  id\n  uuid\n  description\n  descriptionWhy\n  descriptionMeasurement\n  canPostUpdate\n  workspace {\n    uuid\n    id\n  }\n  goalType {\n    kind\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        __typename\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalHeader on Goal {\n  ...GoalTitle\n  ...GoalHeaderBreadcrumbs\n  ...PlatformGoalIcon\n  ...GoalMetaActions\n  ...GoalTabsRefreshed_okloi\n}\n\nfragment GoalHeaderBreadcrumbs on Goal {\n  parentGoals {\n    edges {\n      node {\n        id\n        key\n        name\n      }\n    }\n  }\n  name\n  key\n}\n\nfragment GoalMetaActions on Goal {\n  key\n  ...GoalStateAndTargetDate\n  ...GoalFollowButton\n  ...GoalActions\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProgressEditor on Goal {\n  id\n  progress {\n    percentage\n    type\n  }\n  subGoals {\n    count\n  }\n  latestUserUpdate {\n    metricUpdate {\n      edges {\n        node {\n          newValue {\n            time\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            value\n            id\n          }\n        }\n        metricTargetPeriods {\n          edges {\n            node {\n              date {\n                dateRange {\n                  start\n                }\n              }\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProjects on Goal {\n  id\n  archived\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n    ...ProjectTable\n    ...ContributingProjectsSummary\n  }\n  ...LinkGoalProject\n}\n\nfragment GoalProjectsTab on Goal {\n  goalType {\n    kind\n    id\n  }\n  projects(tql: \"archived = false\", first: 200) {\n    count\n  }\n  subGoals {\n    count\n  }\n  ...GoalProjects\n  ...GoalSubGoals\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStateAndDatePicker_capabilities on TownsquareGoalCapabilities {\n  canEditTargetDate\n  ...GoalStatePickerWrapper\n}\n\nfragment GoalStateAndTargetDate on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n    atCompletionState {\n      value\n      score\n    }\n  }\n  ...GoalDatePicker\n}\n\nfragment GoalStatePickerWrapper on TownsquareGoalCapabilities {\n  ...GoalStatePicker_statusCapabilities\n}\n\nfragment GoalStatePicker_statusCapabilities on TownsquareGoalCapabilities {\n  canEditStatus\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newGoalState: newState {\n    ...GoalState\n  }\n  oldGoalState: oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalSubGoals on Goal {\n  id\n  ari\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        capabilities {\n          canAddLinkedProjects\n          canRemoveLinkedProjects\n        }\n        ...GoalSummaryPanel\n        ...CompactGoalSummaryPanel\n        ...GoalProjects\n      }\n    }\n  }\n}\n\nfragment GoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment GoalTabsRefreshed_okloi on Goal {\n  key\n  watching\n  userUpdateCount\n  canEditUpdate\n  learningsCount\n  risksCount\n  decisionsCount\n  ...GoalAboutTab\n  ...GoalUpdatesTab_okloi\n  ...GoalProjectsTab\n  ...useUserHasCapabilitiesFromGoal\n}\n\nfragment GoalTitle on Goal {\n  name\n  id\n  goalType {\n    ...goalTypeName\n    id\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  ari\n  uuid\n  hasConnectedUpdates\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateMetricChart\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  bundledUpdates(first: 50) {\n    edges {\n      goal {\n        progress {\n          percentage\n        }\n        id\n      }\n    }\n  }\n  goal {\n    id\n    progress {\n      percentage\n    }\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n    ...MetricChart\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateComposer_okloi on Goal {\n  ...DueDateContext\n  ...NewGoalUpdate_okloi\n  ...AddToMissedUpdateMessage\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    input\n    ...DraftGoalUpdate\n    id\n  }\n  metricTargets @include(if: $goalUpdateDraftsEnabled) {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        metric {\n          type\n          subType\n          id\n        }\n      }\n    }\n  }\n  latestUserUpdate {\n    id\n  }\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    aiConfig {\n      enabled\n    }\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  missedUpdate\n  creationDate\n  editDate\n  metricUpdate {\n    edges {\n      node {\n        newValue {\n          time\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateMetricChart on GoalUpdate {\n  creationDate\n  newDueDate {\n    dateRange {\n      end\n    }\n  }\n  newState {\n    value\n    score\n  }\n  metricUpdate {\n    edges {\n      node {\n        newTargetValue\n        metric {\n          name\n          type\n          subType\n          archived\n          values(first: 100, sort: [TIME_DESC]) {\n            edges {\n              node {\n                value\n                time\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newGoalState: newState {\n    value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalUpdatesTab_okloi on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  targetDate\n  targetDateConfidence\n  ...GoalUpdateComposer_okloi\n  ...UpdatesList\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    id\n  }\n}\n\nfragment LinkGoalProject on Goal {\n  id\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment NewGoalUpdate_okloi on Goal {\n  id\n  uuid\n  key\n  workspace {\n    uuid\n    id\n  }\n  phase {\n    name\n  }\n  state {\n    value\n    score\n  }\n  watchers {\n    count\n  }\n  latestUserUpdate {\n    id\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  parentGoal {\n    uuid\n    id\n  }\n  ...hasMetric\n  ...GoalProgressEditor\n  ...SuccessMeasureChart\n  capabilities {\n    ...GoalStateAndDatePicker_capabilities\n  }\n  draftUpdate @include(if: $goalUpdateDraftsEnabled) {\n    input\n    ...DraftGoalUpdate\n    id\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  icon {\n    id\n    shortName\n  }\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTable on ProjectConnection {\n  edges {\n    node {\n      id\n      newPhase {\n        _id: id\n      }\n      ...ProjectTableRow\n      ...ProjectTableCompactRow\n    }\n  }\n}\n\nfragment ProjectTableCompactRow on Project {\n  id\n  key\n  name\n  state {\n    ...ProjectState\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectTableRow on Project {\n  id\n  owner {\n    id\n    ...UserAvatar_2aqwkz\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment SuccessMeasureCardFragment on Goal {\n  ari\n  key\n  name\n  state {\n    ...GoalState\n    value\n  }\n  owner {\n    pii {\n      name\n      picture\n    }\n    id\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          name\n          id\n        }\n        targetValue\n        snapshotValue {\n          value\n          id\n        }\n        id\n      }\n    }\n  }\n  ...SuccessMeasureChart\n  ...metricInfoSectionContent\n  id\n}\n\nfragment SuccessMeasureChart on Goal {\n  id\n  state {\n    value\n  }\n  metricTargets {\n    edges {\n      node {\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          values(first: 100, sort: [TIME_ASC]) {\n            edges {\n              node {\n                id\n                ari\n                canDelete\n                value\n                time\n                creator {\n                  name\n                  picture\n                }\n                origin {\n                  __typename\n                  ... on FromGoalUpdate {\n                    goalUpdate {\n                      creationDate\n                      goal {\n                        id\n                      }\n                      newState {\n                        value\n                        score\n                      }\n                      id\n                    }\n                  }\n                  ... on FromMetricCreation {\n                    creationDate\n                  }\n                  ... on FromMetricUpdate {\n                    updateDate\n                  }\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n        }\n        metricValues(first: 100, sort: [TIME_ASC]) {\n          edges {\n            node {\n              time\n              id\n            }\n            metricTargetPeriod {\n              date {\n                dateRange {\n                  end\n                }\n              }\n              value\n            }\n            variance\n          }\n        }\n        metricTargetPeriods {\n          edges {\n            node {\n              date {\n                dateRange {\n                  end\n                }\n              }\n              value\n              latestValue {\n                node {\n                  value\n                  id\n                }\n                variance\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  targetDate\n}\n\nfragment SuccessMeasureMetricSection on Goal {\n  id\n  key\n  ari\n  metricTargets {\n    edges {\n      node {\n        __typename\n        id\n        ari\n        metric {\n          id\n          ari\n          name\n          type\n          subType\n          archived\n          externalEntityId\n        }\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n      }\n    }\n  }\n  ...SuccessMeasureMetricSectionEmptyState\n  ...SuccessMeasureChart\n  ...metricInfoSectionContent\n  ...GoalProgressEditor\n}\n\nfragment SuccessMeasureMetricSectionEmptyState on Goal {\n  ari\n}\n\nfragment SuccessMeasuresSectionFragment on Goal {\n  ari\n  archived\n  goalType {\n    kind\n    successMeasure {\n      state\n      ari\n      ...goalTypeName\n      ...goalTypeNamePlural\n      id\n    }\n    ...goalTypeName\n    id\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      __typename\n      node {\n        id\n        archived\n        ...SuccessMeasureCardFragment\n      }\n    }\n  }\n  id\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesList on Goal {\n  canEditUpdate\n  updateStreak\n  ...EmptyStateNoUpdates\n  updates(first: 30) {\n    edges {\n      node {\n        uuid\n        creationDate\n        ...EditableGoalUpdateCard\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment dropdownMenu on Goal {\n  accessLevel\n}\n\nfragment goalTypeName on GoalType {\n  name {\n    __typename\n    ... on GoalTypeCustomName {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment goalTypeNamePlural on GoalType {\n  ...goalTypeName\n  namePlural {\n    __typename\n    ... on GoalTypeCustomNamePlural {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment inlineCurrentValueUpdate on Goal {\n  id\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        metric {\n          id\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSectionContent on Goal {\n  id\n  ...inlineCurrentValueUpdate\n  ...progressBarMetricTarget\n  ...hasMetric\n  ...MetricChart\n  ...ChangeRollupTypePopup\n  ...dropdownMenu\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n      ...goalTypeName\n      ...goalTypeNamePlural\n    }\n    id\n    kind\n  }\n  subGoals {\n    edges {\n      node {\n        progress {\n          percentage\n        }\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          percentage\n          type\n        }\n        archived\n        goalType {\n          ...goalTypeName\n          ...goalTypeNamePlural\n          id\n        }\n        id\n      }\n    }\n    pageInfo {\n      hasNextPage\n    }\n  }\n  parentGoal {\n    id\n    ari\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        ari\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          ari\n          archived\n          uuid\n          name\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useUserHasCapabilitiesFromGoal on Goal {\n  workspace {\n    currentUserAppCapabilities {\n      capabilities {\n        capability\n        capabilityContainer\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7646b79536d83666c60f60f921675a7b";

export default node;
